import classNames from "classnames";

import ProductsAd from "../ProductsAd";

const ProductsHeroAd = ({
  useUpdatedHeroStyling,
}: {
  useUpdatedHeroStyling: boolean;
}) => (
  <div
    className={classNames(
      "container min-h-[199px] md:min-h-[208px] lg:min-h-[278px] flex items-center",
      {
        "mb-sm": useUpdatedHeroStyling,
        "my-xl": !useUpdatedHeroStyling,
      },
    )}
  >
    <ProductsAd unit="category_hero" className="w-full" />
  </div>
);

export default ProductsHeroAd;
